interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SYP";
};

const SYP: Currency = Object.freeze({
  "displayName": "Syrian Pound",
  "numericCode": 760,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SYP",
  "symbol": "£"
});

export { SYP };
